import { FunctionComponent } from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { DescriptionField2 } from 'components/UI';

interface Props {
    title: string;
    placeholder: string;
    staffId?: number;
    readOnly?: boolean;
    notes: string;
    onChangeNote: (value: string) => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            paddingBottom: 13,
            [theme.breakpoints.up('md')]: {
                paddingBottom: 15
            }
        },
        title: {
            fontWeight: 600,
            fontSize: 16,
            lineHeight: '120%',
            marginBottom: 18,
            [theme.breakpoints.up('md')]: {
                marginBottom: 20
            }
        },
        notesField: {
            'lineHeight': '18px',
            '& .MuiInputBase-root': {
                alignItems: 'start',
                paddingLeft: 2,
                paddingTop: 4,
                height: 117,
                borderRadius: 20
            },
            '& .MuiOutlinedInput-notchedOutline': {
                borderRadius: 20
            },
            '& .MuiInputBase-input::placeholder': {
                color: '#222222 !important',
                opacity: 1
            },
            '& .MuiOutlinedInput-inputMultiline': {
                padding: '16px 24px !important'
            }
        }
    })
);

export const StaffSelector: FunctionComponent<Props> = props => {
    const classes = useStyles();

    return (
        <Box className={classes.container}>
            <Typography className={classes.title}>{props.title}</Typography>
            <div id="booking_input_notes">
                <DescriptionField2
                    name="notes"
                    placeholder={props.placeholder}
                    label=""
                    className={classes.notesField}
                    value={props.notes}
                    onChange={props.onChangeNote}
                    maxRows={3}
                />
            </div>
        </Box>
    );
};

export default StaffSelector;
